// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2rkhQ","title":"Info_title__hXnel","links":"Info_links__1dleJ","link":"Info_link__U08ma","logo":"Info_logo__OxGrP"};